
export function backboneModelProperties(value: IBackboneModelProperties): any {
    return function decorator(target: any) {
        _.extend(target.prototype, value);
    };
}

export function backboneCollectionProperties(value: IBackboneCollectionProperties): any {
    return function decorator(target: any) {
        _.extend(target.prototype, value);
    };
}

export function backboneViewProperties(value: IBackboneViewProperties): any {
    return function decorator(target: any) {
        _.extend(target.prototype, value);
    };
}

export function backboneRouterProperties(value: IBackboneRouterProperties): any {
    return function decorator(target: any) {
        _.extend(target.prototype, value);
    };
}

export interface IBackboneModelProperties {
    relations?: Backbone.Associations.IRelation[];
    url?: string;
    urlRoot?: string;
    idAttribute?: string;
    defaults?: Backbone.ObjectHash;
}

export interface IBackboneViewProperties {
    tagName?: string;
    className?: string;
    template?: string;
    childView?: any;
    emptyView?: any;
    childViewContainer?: any;
    el?: string;
    id?: string;
    childEvents?(): Backbone.EventsHash;
}

export interface IBackboneCollectionProperties {
    model?: any;
    url?: string;
    urlRoot?: string;
}

export interface IBackboneRouterProperties {
    _routeToRegExp?: (route: any) => RegExp;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/decorators/backbone-properties.ts